import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { PagedCollectionParams } from '../../models/paged-collection-params';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { fleetEnvironment } from './fleet-environment';
import { mapSetPagedCollectionSchema } from './schemas/map-set-paged-collection.schema';

export function getMapSets(params?: PagedCollectionParams) {
  const requestUrl = `${fleetEnvironment.mapSetsUrl}?${
    params ? params.urlParams : ''
  }`;
  return fromFetch(
    new Request(requestUrl, {
      method: 'GET',
      headers: {
        ...requiredHeaders,
        ...new FleetJwtAuthHeaders(),
      },
    })
  ).pipe(selectData(mapSetPagedCollectionSchema));
}
